export default __webpack_public_path__ + "static/media/Chillax-Regular.69ecbaec.woff";